import { Injectable } from '@angular/core';
import { AiAgentChatMessage } from './ai-agent-chat-message.models';
import { AiAgentStreamItem } from './ai-agent-stream-item.models';
import { PendingConfirmation } from './pending-confirmation.models';

@Injectable({ providedIn: 'root' })
export class AiAgentChatMappingService {
    toToolProgressMessage(item: AiAgentStreamItem): AiAgentChatMessage {
        return {
            id: crypto.randomUUID(),
            role: 'tool-progress',
            content: `Running: ${item.toolName ?? 'tool'}…`,
            toolName: item.toolName,
            timestamp: new Date(),
        };
    }

    toAssistantMessage(content: string, timestamp: string | undefined): AiAgentChatMessage {
        return {
            id: crypto.randomUUID(),
            role: 'assistant',
            content,
            timestamp: timestamp ? new Date(timestamp) : new Date(),
        };
    }

    toConfirmationMessage(item: AiAgentStreamItem): AiAgentChatMessage {
        return {
            id: crypto.randomUUID(),
            role: 'confirmation',
            content: item.description ?? 'Confirmation required',
            actionId: item.actionId,
            actionType: item.actionType,
            timestamp: new Date(),
        };
    }

    toPendingConfirmation(item: AiAgentStreamItem): PendingConfirmation {
        return {
            actionId: item.actionId ?? '',
            actionType: item.actionType ?? '',
            description: item.description ?? '',
            details: item.details ?? '',
        };
    }

    toErrorMessage(item: AiAgentStreamItem): AiAgentChatMessage {
        return {
            id: crypto.randomUUID(),
            role: 'assistant',
            content: `Error: ${item.message ?? 'Unknown error'}`,
            timestamp: new Date(),
        };
    }
}
